import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class DropdownService {

  private dropdownSubject = new Subject<string>();
  private isDropdownOpenSubject = new BehaviorSubject<boolean>(true);

  dropdownState$ = this.dropdownSubject.asObservable();
  isDropdownOpen$ = this.isDropdownOpenSubject.asObservable();

  toggleDropdown() {
    this.isDropdownOpenSubject.next(!this.isDropdownOpenSubject.value);
  }

  openDropdown(id: string) {
    this.dropdownSubject.next(id);
  }

  isDropdownOpen() {
    return this.isDropdownOpenSubject.value;
  }

  setInitialState(isOpen: boolean): void {
    this.isDropdownOpenSubject.next(isOpen);
  }
}
